import dayjs from 'dayjs';

/** Demo account used for public demo login — dashboard date pickers are limited to seeded data. */
export const DEMO_DASHBOARD_USER_ID = 63;

export const DEMO_DASHBOARD_DATE_MIN = dayjs('2026-02-13', 'YYYY-MM-DD');
export const DEMO_DASHBOARD_DATE_MAX = dayjs('2026-04-13', 'YYYY-MM-DD');

const DATE_FMT = 'YYYY-MM-DD';

export function isDemoDashboardDateUser(userData) {
    const id = userData?.user?.user_data?.id ?? userData?.user?.id;
    return Number(id) === DEMO_DASHBOARD_USER_ID;
}

export function disabledDateForDemoDashboard(current) {
    if (!current) return false;
    return (
        current.isBefore(DEMO_DASHBOARD_DATE_MIN, 'day') ||
        current.isAfter(DEMO_DASHBOARD_DATE_MAX, 'day')
    );
}

export function validateDemoDashboardDayjs(d) {
    if (!d || !d.isValid()) {
        return { ok: false, message: 'Please enter a valid date.' };
    }
    if (d.isBefore(DEMO_DASHBOARD_DATE_MIN, 'day') || d.isAfter(DEMO_DASHBOARD_DATE_MAX, 'day')) {
        return {
            ok: false,
            message: `Demo data is only available from ${DEMO_DASHBOARD_DATE_MIN.format('MMM D, YYYY')} to ${DEMO_DASHBOARD_DATE_MAX.format('MMM D, YYYY')}.`,
        };
    }
    return { ok: true };
}

export function validateDemoDashboardRange(start, end) {
    if (!start || !end || !start.isValid() || !end.isValid()) {
        return { ok: false, message: 'Please enter a valid date range.' };
    }
    if (start.isAfter(end, 'day')) {
        return { ok: false, message: 'Start date must be on or before the end date.' };
    }
    if (start.isBefore(DEMO_DASHBOARD_DATE_MIN, 'day') || end.isAfter(DEMO_DASHBOARD_DATE_MAX, 'day')) {
        return {
            ok: false,
            message: `Demo data is only available from ${DEMO_DASHBOARD_DATE_MIN.format('MMM D, YYYY')} to ${DEMO_DASHBOARD_DATE_MAX.format('MMM D, YYYY')}.`,
        };
    }
    return { ok: true };
}

export function getDefaultOtherRangeForDemoDashboard() {
    const end = DEMO_DASHBOARD_DATE_MAX;
    const startCandidate = end.subtract(29, 'day');
    const start = startCandidate.isBefore(DEMO_DASHBOARD_DATE_MIN, 'day')
        ? DEMO_DASHBOARD_DATE_MIN
        : startCandidate;
    return {
        start_date: start.format(DATE_FMT),
        end_date: end.format(DATE_FMT),
    };
}

/** Presets anchored to demo data end date so quick picks stay inside the allowed window. */
export function buildDemoDashboardRangePresets() {
    const anchor = DEMO_DASHBOARD_DATE_MAX;
    return [
        { label: 'Today', value: [anchor, anchor] },
        { label: 'Yesterday', value: [anchor.subtract(1, 'day'), anchor.subtract(1, 'day')] },
        { label: 'This Month', value: [anchor.startOf('month'), anchor] },
        {
            label: 'Last Month',
            value: [anchor.subtract(1, 'month').startOf('month'), anchor.subtract(1, 'month').endOf('month')],
        },
        { label: 'Last 7 Days', value: [anchor.subtract(6, 'day'), anchor] },
        { label: 'Last 14 Days', value: [anchor.subtract(13, 'day'), anchor] },
        { label: 'Last 30 Days', value: [anchor.subtract(29, 'day'), anchor] },
        { label: 'Last 60 Days', value: [anchor.subtract(59, 'day'), anchor] },
        { label: 'Custom Range', value: [0, 0] },
    ];
}
